import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  UpdateSpeakerPayload,
  SpeakerResponse
} from '@utils/types/organization/speaker.ts';

interface UpdateSpeakerParams {
  speakerId: number;
  payload: UpdateSpeakerPayload;
}

const putSpeaker = async ({
  speakerId,
  payload
}: UpdateSpeakerParams): Promise<SpeakerResponse> => {
  const { data } = await Axios.put<SpeakerResponse>(
    PUT_URL(String(speakerId)).updateSpeaker,
    payload
  );
  return data;
};

export const useUpdateSpeaker = () => {
  const queryClient = useQueryClient();

  return useMutation<
    SpeakerResponse,
    AxiosError<BaseError>,
    UpdateSpeakerParams
  >(putSpeaker, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(['speakers']);
      queryClient.invalidateQueries(['speaker', variables.speakerId]);
    },
    useErrorBoundary: false
  });
};
